export default __webpack_public_path__ + "static/media/input-category.f95e0854.svg";